import React, { Component } from 'react'
import styled from 'styled-components'
import * as Styles from '../assets/_styles'

const FooterContainer = styled.div`
  width: 100vw;
  background-color: #222;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  align-items: flex-start;
  padding: 32px 48px;
  color: #eee;
  font-weight: 300;
  font-size: 0.8em;
  line-height: 1.5;
  box-sizing: border-box;
  ${Styles.media.tablet`
    display: flex;
    font-size: 0.7em;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 32px 16px;
    > ${FooterContent} {
      &:last-of-type { display: none; }
    }
  `};
`

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 0 0 1em;
  }
`
const Links = styled.div`
  a {
    display: block;
    text-align: right;
  }
`
const NavLink = ({ dest, name }) => (
  <a
    onClick={() => {
      document.querySelector(dest).scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth',
      })
    }}
  >
    {name}
  </a>
)

class Footer extends Component {
  render() {
    return (
      <FooterContainer>
        <FooterContent>
          <p>
            Zinc Technologies<br />545 Sutter St #304<br />San Francisco, CA
            94102
          </p>
          <a href="mailto:sales@zinc.io">sales@zinc.io</a>
        </FooterContent>
        <FooterContent style={{ textAlign: 'center' }}>
          © Zinc 2023
        </FooterContent>
        <FooterContent>
          <Links>
            <NavLink dest="#who" name="About" />
            <NavLink dest="#api" name="API" />
            <NavLink dest="#products" name="Products" />
            <NavLink dest="#enterprise" name="Enterprise" />
            <NavLink dest="#contact" name="Contact Us" />
          </Links>
        </FooterContent>
      </FooterContainer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js